<template>
    <div :class="iconButtonMergedClasses">
        <Icon :type="icon" :filled="iconFilled" :class="iconClasses" />
    </div>
</template>
<script setup lang="ts">
    import { computed } from 'vue'
    import { Icon, IconType } from '../icons'
    import { twMerge } from 'tailwind-merge'

    const props = withDefaults(
        defineProps<{
            class?: any
            variant?: 'primary' | 'light' | 'outline' | 'transparent-light' | 'transparent-dark' | 'dark' | 'alert'
            size?: 'xs' | 'sm' | 'md' | 'lg'
            icon?: IconType | undefined
            iconFilled?: boolean
        }>(),
        {
            size: 'md',
            variant: 'outline',
            icon: 'close',
            iconFilled: false
        }
    )

    const iconClasses = computed(() => {
        const sizeOptions = {
            xs: 'w-3',
            sm: 'w-4',
            md: 'w-4',
            lg: 'w-4'
        }
        return [sizeOptions[props.size]]
    })

    const iconButtonBaseClasses = computed(() => {
        const baseClasses = 'aspect-square rounded-full flex items-center justify-center transition-all duration-200 cursor-pointer text-default select-none'

        const sizeOptions = {
            xs: 'w-5',
            sm: 'w-8',
            md: 'w-10',
            lg: 'w-12'
        }

        const variantOptions = {
            outline: 'bg-system-light border border-surface-border hover:bg-neutral-50 hover:border-surface-border-contained active:bg-neutral-100 active:shadow-sm',
            primary: 'bg-green-500 hover:bg-green-400 active:bg-green-600',
            light: 'bg-system-light shadow-sm hover:shadow active:shadow-inner active:bg-neutral-50',
            'transparent-light': 'text-system-light bg-transparent hover:bg-transparent-light-10 active:bg-system-light active:text-system-dark',
            'transparent-dark': 'bg-transparent hover:bg-transparent-dark-10 active:bg-system-dark active:text-system-light',
            dark: 'bg-system-dark hover:bg-neutral-600 active:bg-neutral-500',
            alert: 'bg-error-500 hover:bg-error-400 active:bg-error-300'
        }
        return [baseClasses, sizeOptions[props.size], variantOptions[props.variant]]
    })

    // Allow overriding base classes
    const iconButtonMergedClasses = computed(() => twMerge(iconButtonBaseClasses.value, props.class))
</script>
